import "core-js/modules/es.number.constructor.js";
//
//
//
//
import echarts from 'echarts';
import { debounce } from '@/utils';
export default {
  props: {
    width: {
      type: Number,
      default: 10
    },
    height: {
      type: Number,
      default: 100
    },
    chartData: {
      // 图表数据
      type: Array,
      default: function _default() {
        return [];
      }
    },
    legendName: {
      // 图例名称
      type: Array,
      default: function _default() {
        return [];
      }
    },
    xAxisData: {
      // x轴数据
      type: Array,
      default: function _default() {
        return [];
      }
    },
    total: {
      // x轴数据
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.chart.clear();
        this.initChart();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    window.removeEventListener('resize', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setOptions: function setOptions(chartData, legendName, xAxisData, total) {
      var colorArr = ['#38C171', '#EEB700', '#C15038', '#5CE5FE', '#63BCDF', '#027BFA', '#C89131', '#FF7723', '#25f295', '#ff9f7f'];
      var nameArr = legendName;
      var totalMoney = total;
      var areaArr = [['#38C171', 'rgba(92, 254, 130, 0)'], ['#EEB700', 'rgba(254, 220, 92, 0)'], ['#C15038', 'rgba(254, 146, 92, 0)'], ['#5CE5FE', 'rgba(92, 254, 130, 0)'], ['#63BCDF', 'rgba(92, 254, 130, 0)'], ['#027BFA', 'rgba(254, 220, 92, 0)'], ['#C89131', 'rgba(254, 146, 92, 0)'], ['#FF7723', 'rgba(92, 254, 130, 0)'], ['#25f295', 'rgba(254, 220, 92, 0)'], ['#ff9f7f', 'rgba(254, 146, 92, 0)']];
      var seriesData = chartData;
      var timeArr = xAxisData;
      var series = [];

      for (var index = 0; index < nameArr.length; index++) {
        series.push({
          name: nameArr[index],
          type: 'line',
          symbolSize: 12,
          smooth: true,
          showSymbol: false,
          itemStyle: {
            color: '#FFFFFF',
            normal: {
              color: colorArr[index],
              lineStyle: {
                width: 3,
                type: 'solid'
              },
              label: {
                show: false
              }
            }
          },
          areaStyle: {
            normal: {
              color: {
                type: 'linear',
                x: 0,
                //右
                y: 1,
                //下
                x2: 0,
                //左
                y2: 0,
                //上
                colorStops: [{
                  offset: 1,
                  color: areaArr[index][0] // 0% 处的颜色

                }, {
                  offset: 0,
                  color: areaArr[index][1] // 100% 处的颜色

                }]
              }
            }
          },
          data: seriesData[index]
        });
      }

      var option = {
        backgroundColor: 'rgba(6, 26, 53)',
        grid: {
          top: "30%",
          left: "1%",
          right: "3%",
          bottom: "0",
          containLabel: true
        },
        legend: {
          type: 'scroll',
          //图例滚动模式
          orient: 'horizontal',
          // vertical 滚动方向
          pageIconColor: "white",
          //激活的分页按钮颜色
          pageIconInactiveColor: "#2f4554",
          //没激活的分页按钮颜色
          pageTextStyle: {
            color: "white" //分页文字颜色

          },
          width: '44%',
          top: 12,
          itemWidth: 16,
          itemHeight: 20,
          itemGap: 10,
          icon: 'circle',
          x: 'right',
          //可设定图例在左、右、居中
          y: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 10,
            fontWeight: 400
          }
        },
        tooltip: {
          trigger: "axis",
          show: true,
          axisPointer: {
            lineStyle: {
              color: 'none' //   不显示线条

            }
          },
          borderColor: "rgba(6, 26, 53)",
          textStyle: {
            color: "#FFF"
          }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          boundaryGap: false,
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            inside: false,
            interval: parseInt(timeArr.length / 10),
            rotate: 0,
            textStyle: {
              color: '#fff',
              fontWeight: 400,
              fontSize: 12
            },
            margin: 10
          },
          data: timeArr
        },
        yAxis: {
          type: 'value',
          name: '月总收入：￥' + totalMoney,
          nameTextStyle: {
            color: '#0b98ff',
            fontSize: 16,
            fontWeight: 800,
            padding: [0, 0, 5, 100]
          },
          nameGap: 10,
          axisTick: {
            show: false
          },
          splitArea: {
            show: false //去掉背景透明白色条纹

          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.18)'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontWeight: 400,
              fontSize: 12
            },
            formatter: '{value}',
            margin: 10
          }
        },
        series: series
      };
      this.chart.setOption(option);
    },
    initChart: function initChart() {
      this.chart = echarts.init(this.$refs.myEchart, 'macarons');
      this.setOptions(this.chartData, this.legendName, this.xAxisData, this.total);
    }
  }
};